enum AdSdkProvider {
  IMA = 'ima_sdk',
  TEADS = 'teads_sdk',
}

enum PlayAdType {
  L_LIVE = 'lAdLive',
  L_VOD = 'lAdVod',
}

export { AdSdkProvider, PlayAdType };
